module.exports = __webpack_public_path__ + "img/hr-heated-ending-right-1.4df955dd.png";